import React from "react";

const Hero = () => {
  return (
    <section
      id="home"
      className="hero-section bg-primary text-white py-5"
      style={{ marginTop: "76px" }}
    >
      <div className="container">
        <div className="row align-items-center min-vh-75">
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold mb-4">
              Premium Server Solutions for Your Business
            </h1>
            <p className="lead mb-4">
              Experience lightning-fast performance, 99.9% uptime, and
              enterprise-grade security with our cutting-edge server
              infrastructure.
            </p>
            <div className="d-flex flex-wrap gap-3">
              <button className="btn btn-light btn-lg px-4">
                <i className="fas fa-rocket me-2"></i>
                Start Free Trial
              </button>
              <button className="btn btn-outline-light btn-lg px-4">
                <i className="fas fa-play me-2"></i>
                Watch Demo
              </button>
            </div>

            <div className="row mt-5">
              <div className="col-4">
                <h3 className="fw-bold">99.9%</h3>
                <p className="mb-0">Uptime</p>
              </div>
              <div className="col-4">
                <h3 className="fw-bold">24/7</h3>
                <p className="mb-0">Support</p>
              </div>
              <div className="col-4">
                <h3 className="fw-bold">50k+</h3>
                <p className="mb-0">Clients</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="text-center">
              <div className="bg-white bg-opacity-10 rounded-3 p-4">
                <i className="fas fa-server display-1 mb-3"></i>
                <div className="row">
                  <div className="col-6 mb-3">
                    <div className="bg-success rounded p-2">
                      <i className="fas fa-check"></i> SSL Secured
                    </div>
                  </div>
                  <div className="col-6 mb-3">
                    <div className="bg-info rounded p-2">
                      <i className="fas fa-shield-alt"></i> DDoS Protected
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="bg-warning rounded p-2 text-dark">
                      <i className="fas fa-bolt"></i> High Speed
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="bg-danger rounded p-2">
                      <i className="fas fa-cloud"></i> Cloud Ready
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
